import React, { useEffect, useState } from 'react';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getSociaMediaIcons, getTemplateDetail } from "../../../../utils/sociaMediaIconsApi";

const SocialIconsTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, socialMediaIconsTabData, refreshWidgetList }) => {
    const [apiData, setApiData] = useState(false);

    const {
        is_website_frontend,
        icon_size,
        location_type,
        position_type,
        social_custom_class,
        icons_shape_type,
        icon_color,
        background_color,
        icon_color_on_hover,
        background_color_on_hover,  
        opacity_size,
        opacity_on_hover_size,
    } = socialMediaIconsTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/social-media-icons/temp-css/SocialMediaIcons.css`;
        if (widgetId) {
            link.setAttribute("social-media-icons-data-dynamic-css", "social-media-icons");
        } else {
          link.setAttribute("data-dynamic-css", "social-media-icons");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="social-media-icons"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    useEffect(() => {
        const fetchData = async () => {
        try {
            if (isTemplateId) {
            const result = await getTemplateDetail(isTemplateId);
            setApiData(result);
            } else if (widgetId) {
            const result = await getSingleWidgetDetail(widgetId);
            setApiData(result);
            } else {
            const result = await getSociaMediaIcons();
            setApiData(result);
            }
        } catch (error) {
            // handle error
        }
        };

        if (isTemplateId !== undefined || widgetId !== undefined) {
        fetchData();
        }
    }, [isTemplateId, widgetId, refreshWidgetList]);
    //Store Api data
    const socialIcons = apiData?.data?.data_list || [];

    // Function to force replace all fill value
    const colorizeSvg = (svgString, colorChoice) => {
        if (!svgString || colorChoice === 'native') return svgString;

        // Remove existing fills and inline styles
        let cleaned = svgString
            .replace(/fill=".*?"/gi, '')
            .replace(/style="[^"]*?fill:[^;"]*;?[^"]*?"/gi, '');

        // Inject fill to all tags except <svg>
        cleaned = cleaned.replace(/<(\w+)([^>]*)>/g, (match, tag, attrs) => {
            if (tag === 'svg') return match;
            return `<${tag}${attrs} fill="${colorChoice}">`;
        });

        return cleaned;
    };

    const getBackgroundColor = (bgColor) => {
        if (bgColor === 'native') return 'transparent';
        if (bgColor === 'black') return '#000';
        if (bgColor === 'white') return '#fff';
        return bgColor || 'transparent';
    };

    // Calculate increased container size (3x icon_size)
    const iconNumericSize = parseInt(icon_size);
    const parentSize = iconNumericSize * 1.5;

  return (
    <>
      <div className={`upgadeify social_media_icons social-icons-temp ${is_website_frontend}`}>
        {socialIcons.length > 0 ? (
          <div className='social-icons-temp__container'>
            <div className={`social-icons-temp__main ${location_type || ''} ${position_type || ''} ${social_custom_class || ''}`}>
              {socialIcons.map((icon, index) => (
                <a
                    key={index}
                    href={icon?.icon_url || '#'}
                    target='_blank'
                    rel='noopener noreferrer'
                    title={icon?.icon_lable || ''}
                    aria-label={icon?.icon_lable || ''}
                    className={icons_shape_type}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: parentSize + 'px',
                        height: parentSize + 'px',
                        backgroundColor: getBackgroundColor(background_color),
                        borderRadius: '100px',
                        opacity: opacity_size
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = getBackgroundColor(background_color_on_hover || background_color);
                        e.currentTarget.style.opacity = opacity_on_hover_size || '1';
                        const svgContainer = e.currentTarget.querySelector('.svg-wrapper');
                        if (svgContainer) svgContainer.innerHTML = colorizeSvg(icon?.svg_icon, icon_color_on_hover);
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = getBackgroundColor(background_color);
                        e.currentTarget.style.opacity = '1';
                        const svgContainer = e.currentTarget.querySelector('.svg-wrapper');
                        if (svgContainer) svgContainer.innerHTML = colorizeSvg(icon?.svg_icon, icon_color);
                    }}
                >
                  <div
                    style={{ width: icon_size, height: icon_size }}
                    dangerouslySetInnerHTML={{
                      __html: colorizeSvg(icon?.svg_icon, icon_color),
                    }}
                  />
                </a>
              ))}
            </div>
          </div>
        ) : (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading please wait...</p>
          </div>
        )}
      </div>
    </>
  );
};

export default SocialIconsTemplateWidget;
